// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gym-status {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    text-align: center;
    padding: 20px;
    /* Added padding for mobile responsiveness */
    box-sizing: border-box;
}

.header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    /* Reduced margin for mobile */
}

.site-name {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
}

.logo {
    width: 150px;
    /* Adjust width as needed */
    height: auto;
    /* Maintain aspect ratio */
    margin-bottom: 20px;
    /* Add margin to create spacing below the logo */
}

.logo svg {
    width: 100%;
    height: auto;
}

.content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.status-text {
    font-size: 18px;
    margin-bottom: 10px;
}

.people-count {
    font-size: 32px;
    font-weight: bold;
}

/* Media query for mobile responsiveness */
@media (max-width: 600px) {
    .site-name {
        font-size: 18px;
    }

    .logo {
        font-size: 16px;
    }

    .status-text {
        font-size: 16px;
    }

    .people-count {
        font-size: 28px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/GymStatus.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,0CAA0C;AAC1C;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".gym-status {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    text-align: center;\n    padding: 20px;\n    /* Added padding for mobile responsiveness */\n    box-sizing: border-box;\n}\n\n.header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 20px;\n    /* Reduced margin for mobile */\n}\n\n.site-name {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.logo {\n    width: 150px;\n    /* Adjust width as needed */\n    height: auto;\n    /* Maintain aspect ratio */\n    margin-bottom: 20px;\n    /* Add margin to create spacing below the logo */\n}\n\n.logo svg {\n    width: 100%;\n    height: auto;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.status-text {\n    font-size: 18px;\n    margin-bottom: 10px;\n}\n\n.people-count {\n    font-size: 32px;\n    font-weight: bold;\n}\n\n/* Media query for mobile responsiveness */\n@media (max-width: 600px) {\n    .site-name {\n        font-size: 18px;\n    }\n\n    .logo {\n        font-size: 16px;\n    }\n\n    .status-text {\n        font-size: 16px;\n    }\n\n    .people-count {\n        font-size: 28px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
